module.exports = __webpack_public_path__ + "static/media/science.78df0671.svg";